import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    new PreviewOverlay($("a[data-preview-url]", this.element));
  }
}
